import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../auth/PrivateRoute';

/**
 * Build an array of <Route> elements from the enabled-module descriptors.
 * Spread the return value inside a <Routes> block — React Router flattens
 * arrays of <Route> children, but will NOT descend through a custom
 * component, so we cannot return a single wrapper component.
 */
export const buildModuleRoutes = (modules) =>
  (modules || []).flatMap(m =>
    (m.routes || []).map(r => (
      <Route
        key={`${m.id}:${r.path}`}
        path={r.path}
        element={r.private ? <PrivateRoute>{r.element}</PrivateRoute> : r.element}
      />
    ))
  );
